import axios from "axios";

const API_BASE_URL = "https://backend.gouniquejourneys.co.uk/api/employee/leave"; // Change as per your backend

// Apply for a leave
export const applyLeave = async (leaveData) => {
  try {
    const formattedData = {
        ...leaveData,
        startDate: new Date(leaveData.fromDate).toISOString(), // Convert to valid date format
        endDate: new Date(leaveData.toDate).toISOString(), // Convert to valid date format
      };
    const response = await axios.post(`${API_BASE_URL}/apply-leave`, formattedData,
        {
            headers: { 
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error applying leave";
  }
};

// Get leaves for a specific employee
export const getEmployeeLeaves = async (employeeId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/get-employeeLeave/${employeeId}`, {
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching employee leaves";
  }
};

// Get all leaves (admin view)
export const getAllLeaves = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/get-allLeave?page=${page}&limit=${limit}`, {
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching all leaves";
  }
};

// Update a leave
export const updateLeave = async (leaveId, updatedData) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/update-leave/${leaveId}`,
      updatedData, {
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating leave";
  }
};

// Delete a leave
export const deleteLeave = async (leaveId) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/delete-leave/${leaveId}`,  {
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting leave";
  }
};
